import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.rawdata.detail');
import { Input, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import pLimit from 'p-limit';
import * as pdfjsLib from 'pdfjs-dist';

declare const wiz: any;

@Component({
    selector: 'wiz-portal-rawdata-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.rawdata.detail/view.scss */
.grid-cols-16 {
  grid-template-columns: repeat(16, minmax(0, 1fr));
}

.grid-cols-17 {
  grid-template-columns: repeat(17, minmax(0, 1fr));
}`],
})
export class PortalRawdataDetailComponent {
    @Input() id: string;

    public isDragOver: boolean = false;
    private dragCounter: number = 0;
    private navStack: Array<{ path: string; page: number }> = [];

    allItems: any[] = [];
    items: any[] = [];
    pageSize: number = 10;
    currentPage: number = 1;
    totalPages: number = 1;

    datasetId: string = '';
    datasetName: string = '';

    currentPath: string = '/';
    breadcrumbs: any[] = [];

    summaryLoading: boolean = false;
    summaryError: string = '';
    summary: any = null;

    showMkdirModal: boolean = false;
    mkdirName: string = '';
    mkdirError: string = '';

    showRenameModal: boolean = false;
    renameTarget: any = null;
    renameName: string = '';
    renameError: string = '';

    showUploadModal: boolean = false;
    uploadFile: File[] = [];
    uploadError: string = '';
    uploadPreviewLimit: number = 20;

    isUploading: boolean = false;
    showUploadProgressModal: boolean = false;
    uploadProgress: number = 0;
    uploadTotalCount: number = 0;
    uploadCompletedCount: number = 0;
    uploadCurrentName: string = '';
    uploadCancelRequested: boolean = false;
    private currentUploadAbort: AbortController | null = null;

    public PDF: SafeResourceUrl | '' = '';
    public ocrText: string = '';
    public showOCRModal: boolean = false;
    ocrResults: any[] = [];
    currentOCRIndex: number = 0;
    selectedOCRGroup: any = null;

    public pdfDoc: any = null;
    public pdfPageCanvas: string = '';

    public pdfLoading: boolean = false;
    public pdfLoadingProgress: string = '';

    public pdfPageInput: number = 1;
    public pdfZoomLevel: number = 1.5;
    public minZoom: number = 0.5;
    public maxZoom: number = 3.0;

    public pdfCanvasWidth: number = 0;
    public pdfCanvasHeight: number = 0;

    private ocrPollingTimer: any = null;


    constructor(@Inject( Service)         private service: Service,@Inject( DomSanitizer)         private sanitizer: DomSanitizer,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef    )         private cdr: ChangeDetectorRef    ) {
        pdfjsLib.GlobalWorkerOptions.workerSrc =
            'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    }


    get canGoUp(): boolean {
        return !this.isDatasetRoot;
    }
    // 현재 경로가 해당 데이터셋의 루트인지 여부
    get isDatasetRoot(): boolean {
        if (!this.datasetId) return false;
        const path = (this.currentPath || '').replace(/\/+$/, '');
        const root = '/' + this.datasetId;
        return path === root;
    }

    async ngOnInit() {
        this.datasetId = this.id;

        if (!this.datasetId) {
            console.warn('[rawdata-detail] datasetId(id)가 없습니다.');
            return;
        }

        // 상단 요약 먼저 로딩 (id 기준)
        await this.loadSummary();

        // 데이터셋 루트에서 브라우징 시작: /<datasetId>
        const rootPath = '/' + this.datasetId;
        await this.open(rootPath);

        setTimeout(() => this.service.render(), 30);
    }

    // ===== 상단 요약 =====
    async loadSummary() {
        this.summaryLoading = true;
        this.summaryError = '';
        this.summary = null;
        this.service.render();

        try {
            const res = await wiz.call('get_dataset_summary', { id: this.datasetId });

            let payload: any = null;
            if (res && res.code === 200) {
                if (res.data && res.data.data) payload = res.data.data;
                else payload = res.data;
            }

            if (payload) {
                this.summary = payload;
                this.datasetName = payload.dataset_name || this.datasetId;
            } else {
                this.summaryError =
                    (res && (res.error || res.message)) || '요약 정보를 가져오지 못했습니다.';
            }
        } catch (e) {
            console.error('[rawdata-detail] get_dataset_summary error:', e);
            this.summaryError = '요약 정보를 가져오는 중 오류가 발생했습니다.';
        } finally {
            this.summaryLoading = false;
            this.service.render();
        }
    }
    private applyPaginationOnly() {
        this.totalPages = Math.max(1, Math.ceil(this.allItems.length / this.pageSize));

        if (this.currentPage < 1) this.currentPage = 1;
        if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;

        this.items = this.allItems.slice(start, end);
    }

    private syncSelectedIds() {
        if (!this.allItems || this.allItems.length === 0) {
            this.selectedIds.clear();
            return;
        }

        const currentNames = new Set(
            this.allItems
                .map((it: any) => it?.name)
                .filter((name: any) => !!name)
        );

        Array.from(this.selectedIds).forEach((id) => {
            if (!currentNames.has(id)) {
                this.selectedIds.delete(id);
            }
        });
    }

    public sortByOCR() {
        const hasUnprocessed = this.allItems.some(it => this.isProcessableFile(it) && it.ocr !== 'Y');
        if (!hasUnprocessed) return;
        this.allItems.sort((a, b) => (a.ocr_progress ?? 0) - (b.ocr_progress ?? 0));
        this.applyPaginationOnly();
        this.service.render();
    }

    public sortByEMB() {
        const hasUnprocessed = this.allItems.some(it => this.isProcessableFile(it) && it.embedding !== 'Y');
        if (!hasUnprocessed) return;
        this.allItems.sort((a, b) => (a.emb_progress ?? 0) - (b.emb_progress ?? 0));
        this.applyPaginationOnly();
        this.service.render();
    }
    private getVectorSortValue(it: any): number {
        switch (it.vector) {
            case 'processing':
                return 1;
            case 'Y':
                return 2;
            case 'N':
            default:
                return 0;
        }
    }

    public sortByVectorDB() {
        this.allItems.sort((a, b) =>
            this.getVectorSortValue(a) - this.getVectorSortValue(b)
        );
        this.applyPaginationOnly();
        this.service.render();
    }

    // ===== 브라우징 =====
    async open(path: string, restorePage?: number) {
        const p = path || '/' + this.datasetName;
        const res = await wiz.call('browse', { cwd: p });
        const data = res?.data || {};

        const rawItems = data.items || [];

        // *_ocr.json / *_embedding.json 숨기기
        const visibleItems = rawItems.filter((it: any) => {
            if (it.type !== 'file') return true;
            const name = it.name || '';
            if (name.endsWith('.json')) return false;
            return true;
        });

        if (data.items) {
            this.currentPath = data.path || p;
            this.breadcrumbs = data.breadcrumbs || [];
            const itemNames = rawItems.map((x: any) => x.name);

            const dirItems = visibleItems
                .filter((it: any) => it.type !== 'file')
                .map((it: any) => ({
                    ...it,
                    displayName: it.name
                }));

            const groupableExts = ['pdf', 'hwp', 'hwpx'];
            const fileGroups = new Map<
                string,
                { baseName: string; extMap: Record<string, any>; isGroupable: boolean }
            >();

            visibleItems
                .filter((it: any) => it.type === 'file')
                .forEach((it: any) => {
                    const ext = this.getFileExt(it.name);
                    const isGroupable = groupableExts.includes(ext);
                    const baseName = isGroupable ? this.getBaseName(it.name) : it.name;
                    const key = isGroupable ? baseName : it.name;

                    const group = fileGroups.get(key) || {
                        baseName,
                        extMap: {} as Record<string, any>,
                        isGroupable
                    };

                    group.extMap[ext || ''] = it;
                    fileGroups.set(key, group);
                });

            const fileItems = Array.from(fileGroups.values()).map((group) => {
                const availableExts = this.getOrderedExts(group.extMap);
                const primaryExt = this.getPrimaryExt(availableExts);
                const primaryItem = group.extMap[primaryExt] || group.extMap[availableExts[0]];
                const primaryName = primaryItem?.name || group.baseName;
                const ocrTargetName = group.extMap['pdf']?.name || primaryName;
                const displayName = group.isGroupable ? group.baseName : primaryName;

                let ocr = 'N';
                let embedding = 'N';

                if (primaryItem && this.isProcessableFile(primaryItem)) {
                    const ocrFile = group.baseName + '_ocr.json';
                    const embFile = group.baseName + '_embedding.json';

                    if (itemNames.includes(ocrFile)) ocr = 'Y';
                    if (itemNames.includes(embFile)) embedding = 'Y';

                    // 서버 status 우선 적용
                    if (primaryItem.ocr_status === 'processing') {
                        ocr = 'processing';
                    } else if (primaryItem.ocr_status === 'done') {
                        ocr = 'Y';
                    } else if (primaryItem.ocr_status === 'error') {
                        ocr = 'error';
                    }

                    if (primaryItem.embedding_status === 'processing') {
                        embedding = 'processing';
                    } else if (primaryItem.embedding_status === 'done') {
                        embedding = 'Y';
                    } else if (primaryItem.embedding_status === 'error') {
                        embedding = 'error';
                    }
                }

                let ocr_progress_num = 0;
                let emb_progress_num = 0;

                if (ocr === 'Y') ocr_progress_num = 100;
                if (ocr === 'processing') ocr_progress_num = 50;

                if (embedding === 'Y') emb_progress_num = 100;
                if (embedding === 'processing') emb_progress_num = 50;

                const fileVariants = Object.keys(group.extMap).reduce((acc: any, ext) => {
                    const item = group.extMap[ext];
                    if (item?.name) acc[ext] = item.name;
                    return acc;
                }, {} as Record<string, string>);

                return {
                    ...primaryItem,
                    name: primaryName,
                    baseName: group.baseName,
                    displayName,
                    primaryExt,
                    primaryName,
                    ocrTargetName,
                    availableExts,
                    fileVariants,
                    ocr,
                    embedding,
                    ocr_progress: ocr_progress_num,
                    emb_progress: emb_progress_num,
                    _menuOpen: false
                };
            });

            this.allItems = [...dirItems, ...fileItems];

            this.syncSelectedIds();

            if (typeof restorePage === 'number') {
                this.currentPage = restorePage;
            } else {
                this.currentPage = 1;
            }

            this.applySortAndPagination();
        }

        this.service.render();
    }
    async up() {
        if (!this.canGoUp) return;

        const prev = this.navStack.pop();
        if (prev) {
            await this.open(prev.path, prev.page);
            return;
        }

        // 스택이 비어있을 때는 기존 로직대로
        const parts = this.currentPath.split('/').filter(Boolean);
        if (parts.length <= 1) return;

        parts.pop();
        const parent = '/' + parts.join('/');
        await this.open(parent);
    }


    async onItemClick(it: any) {
        if (!it) return;

        if (it.type === 'dir') {
            this.navStack.push({ path: this.currentPath, page: this.currentPage });
            const next = this.join(this.currentPath, it.name);
            await this.open(next);
            return;
        }
    }

    public goBackToList() {
        this.router.navigateByUrl('ui/rawdata');
    }

    // ===== 공통 유틸 =====

    private getFileExt(name: string): string {
        if (!name) return '';
        const idx = name.lastIndexOf('.');
        if (idx < 0) return '';
        return name.substring(idx + 1).toLowerCase();
    }

    private getBaseName(name: string): string {
        if (!name) return '';
        const idx = name.lastIndexOf('.');
        if (idx < 0) return name;
        return name.substring(0, idx);
    }

    private getOrderedExts(extMap: Record<string, any>): string[] {
        const order = ['hwp', 'pdf', 'hwpx', 'txt'];
        const rawExts = Object.keys(extMap);
        const exts = rawExts.filter((ext) => !!ext);
        const ordered = order.filter((ext) => exts.includes(ext));
        const rest = exts.filter((ext) => !order.includes(ext));

        if (exts.length === 0) return rawExts;
        return [...ordered, ...rest];
    }

    private getPrimaryExt(availableExts: string[]): string {
        if (availableExts.includes('pdf')) return 'pdf';
        if (availableExts.includes('hwp')) return 'hwp';
        if (availableExts.includes('hwpx')) return 'hwpx';
        if (availableExts.includes('txt')) return 'txt';
        return availableExts[0] || '';
    }

    private getOcrTargetName(it: any): string {
        if (it?.ocrTargetName) return it.ocrTargetName;
        if (it?.fileVariants?.pdf) return it.fileVariants.pdf;
        return it?.name || '';
    }

    private getOriginalFileNames(it: any): string[] {
        const variants = it?.fileVariants ? Object.values(it.fileVariants) : [];
        if (variants.length > 0) return variants as string[];
        if (it?.name) return [it.name];
        return [];
    }

    isProcessableFile(it: any): boolean {
        if (!it || it.type !== 'file') return false;
        const allowed = ['pdf', 'hwp', 'hwpx', 'txt'];
        const ext = this.getFileExt(it.name);
        return !!ext && allowed.includes(ext);
    }

    join(base: string, name: string): string {
        const b = (base || '/').endsWith('/') ? base : base + '/';
        return (b + name).replace('//', '/');
    }

    formatTime(ts: number): string {
        if (!ts) return '-';
        const d = new Date(ts * 1000);
        const y = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        const hh = d.getHours().toString().padStart(2, '0');
        const mm = d.getMinutes().toString().padStart(2, '0');
        return `${y}-${m}-${day} ${hh}:${mm}`;
    }

    formatSize(n: number): string {
        if (n == null || isNaN(n)) return '-';
        if (n < 1024) return `${n} B`;
        if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
        if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
        return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
    }

    // onCheckedChange() {
    //     this.service.render();
    // }

    // getCheckedFiles() {
    //     return this.items.filter(it => this.isProcessableFile(it) && it.checked);
    // }

    // getCheckedFolders() {
    //     return this.items.filter(it => it.type === 'dir' && it.checked);
    // }
    getCheckedFiles() {
        if (!this.allItems) return [];

        return this.allItems.filter(it =>
            this.isProcessableFile(it) &&
            it?.name &&
            this.selectedIds.has(it.name)
        );
    }

    getCheckedFilesForDelete() {
        if (!this.allItems) return [];

        return this.allItems.filter(it =>
            it?.type === 'file' &&
            it?.name &&
            this.selectedIds.has(it.name)
        );
    }

    getCheckedFolders() {
        if (!this.allItems) return [];

        return this.allItems.filter(it =>
            it.type === 'dir' &&
            it?.name &&
            this.selectedIds.has(it.name)
        );
    }


    // ==== 전체 선택 함수 ====
    // public toggleSelectAll() {
    //     const allChecked = this.items.every(it => it.checked === true);
    //     this.items.forEach(it => it.checked = !allChecked);
    //     this.onCheckedChange();
    // }
    // ==== 정렬 함수 ====
    public sortOption: string = "name_asc";

    public onSortOptionChange() {
        console.log("=== onSortOptionChange ===");
        console.log("sortOption =", this.sortOption);
        this.applySortAndPagination();
        this.service.render();
    }

    // ===== 삭제 (파일/폴더 통합) =====

    // getDeleteState(): string {
    //     const files = this.getCheckedFiles();
    //     const folders = this.getCheckedFolders();

    //     if (files.length === 0 && folders.length === 0) return 'none';
    //     if (files.length > 0 && folders.length === 0) return 'files';
    //     if (files.length === 0 && folders.length > 0) return 'folders';
    //     return 'mixed';
    // }
    getDeleteState(): 'none' | 'files' | 'folders' | 'mixed' {
        const files = this.getCheckedFilesForDelete();
        const folders = this.getCheckedFolders();

        if (files.length === 0 && folders.length === 0) return 'none';
        if (files.length > 0 && folders.length === 0) return 'files';
        if (files.length === 0 && folders.length > 0) return 'folders';

        return 'mixed';
    }

    canDeleteSelected(): boolean {
        const state = this.getDeleteState();
        return state === 'files' || state === 'folders';
    }

    async deleteSelected() {
        const state = this.getDeleteState();

        if (state === 'none') {
            alert('삭제할 항목을 선택하세요.');
            return;
        }

        if (state === 'mixed') {
            alert('폴더와 파일을 동시에 삭제할 수 없습니다.\n폴더만 또는 파일만 선택해 주세요.');
            return;
        }

        if (state === 'files') {
            const files = this.getCheckedFilesForDelete().flatMap((it: any) => this.getOriginalFileNames(it));

            if (files.length === 0) {
                alert('삭제할 파일이 없습니다.');
                return;
            }

            if (!confirm('선택한 파일을 삭제하시겠습니까?')) return;

            const res = await wiz.call('delete_files', {
                cwd: this.currentPath,
                files: JSON.stringify(files)
            });

            if (res && res.code === 200) {
                alert('파일 삭제 완료');
                this.selectedIds.clear();
                await this.open(this.currentPath);
            } else {
                alert(res?.error || '파일 삭제 중 오류 발생');
            }

            return;
        }

        if (state === 'folders') {
            const folders = this.getCheckedFolders().map((f: any) => f.name);

            if (folders.length === 0) {
                alert('삭제할 폴더가 없습니다.');
                return;
            }

            if (!confirm('선택한 폴더를 삭제하시겠습니까?')) return;

            const res = await wiz.call('delete_files', {
                cwd: this.currentPath,
                files: JSON.stringify(folders)
            });

            if (res && res.code === 200) {
                alert('폴더 삭제 완료');
                this.selectedIds.clear();
                await this.open(this.currentPath);
            } else {
                alert(res?.error || '폴더 삭제 중 오류가 발생했습니다.');
            }

            return;
        }
    }

    // ===== OCR / 임베딩 / 벡터 =====

    canRunOCR(): boolean {
        const files = this.getCheckedFiles();
        const folders = this.getCheckedFolders();

        // 파일만 선택 or 폴더만 선택만 허용 (혼합은 불가)
        return (files.length > 0 && folders.length === 0) || (folders.length > 0 && files.length === 0);
    }

    canRunEmbedding(): boolean {
        const files = this.getCheckedFiles();
        const folders = this.getCheckedFolders();

        // 파일만 선택: 기존 조건 유지
        const fileOk =
            files.length > 0 &&
            folders.length === 0 &&
            files.every(f => f.ocr === 'Y');

        // 폴더만 선택: 허용 (실제 OCR 여부 검증은 activeEmbedding에서 재검증)
        const folderOk =
            folders.length > 0 &&
            files.length === 0;

        return fileOk || folderOk;
    }
    canRunVectorInsert(): boolean {
        const files = this.getCheckedFiles();
        const folders = this.getCheckedFolders();

        return (
            files.length > 0 &&
            folders.length === 0 &&
            files.every(f => f.embedding === 'Y')
        );
    }


    // ===== 폴더 생성 =====
    openMkdir() {
        this.mkdirName = '';
        this.mkdirError = '';
        this.showMkdirModal = true;
        this.service.render();
    }

    closeMkdir() {
        this.showMkdirModal = false;
        this.mkdirError = '';
        this.mkdirName = '';
        this.service.render();
    }

    async confirmMkdir() {
        const name = (this.mkdirName || '').trim();

        if (!name) {
            this.mkdirError = '폴더 이름을 입력해 주세요.';
            this.service.render();
            return;
        }
        if (name.includes('/') || name.includes('\\')) {
            this.mkdirError = '폴더명에 경로 구분자를 포함할 수 없습니다.';
            this.service.render();
            return;
        }

        const res = await wiz.call('mkdir', { cwd: this.currentPath, name });

        if (res && res.error) {
            this.mkdirError = '생성에 실패했습니다. (' + res.error + ')';
            this.service.render();
            return;
        }

        this.closeMkdir();
        await this.open(this.currentPath);
    }

    // ===== 폴더 이름 변경 =====
    openRenameFolder(item: any, event: MouseEvent) {
        event.stopPropagation();
        if (!item || item.type !== 'dir') return;
        this.renameTarget = item;
        this.renameName = item.name;
        this.renameError = '';
        this.showRenameModal = true;
        this.service.render();
    }

    closeRenameFolder() {
        this.showRenameModal = false;
        this.renameTarget = null;
        this.renameName = '';
        this.renameError = '';
        this.service.render();
    }

    async confirmRenameFolder() {
        const newName = (this.renameName || '').trim();

        if (!newName) {
            this.renameError = '새 이름을 입력해 주세요.';
            this.service.render();
            return;
        }

        if (!this.renameTarget || this.renameTarget.type !== 'dir') {
            this.renameError = '폴더를 선택해 주세요.';
            this.service.render();
            return;
        }

        if (newName === this.renameTarget.name) {
            this.closeRenameFolder();
            return;
        }

        if (newName.includes('/') || newName.includes('\\')) {
            this.renameError = '이름에 경로 구분자를 포함할 수 없습니다.';
            this.service.render();
            return;
        }

        try {
            const res: any = await wiz.call('rename_folder', {
                cwd: this.currentPath,
                old_name: this.renameTarget.name,
                new_name: newName
            });

            if (res && res.code === 200) {
                this.closeRenameFolder();
                await this.open(this.currentPath);
            } else {
                this.renameError = res?.data?.error || '이름 변경에 실패했습니다.';
                this.service.render();
            }
        } catch (e) {
            console.error('[rawdata-detail] rename_folder error:', e);
            this.renameError = '이름 변경 중 오류가 발생했습니다.';
            this.service.render();
        }
    }

    // ===== 업로드 =====
    openUpload() {
        if (this.isUploading) {
            alert('이미 업로드가 진행 중입니다.');
            return;
        }
        this.showUploadModal = true;
        this.uploadFile = [];
        this.uploadError = '';
        this.service.render();
    }

    closeUpload() {
        this.showUploadModal = false;
        this.uploadFile = [];
        this.uploadError = '';
        this.service.render();
    }

    get uploadPreviewFiles(): File[] {
        return (this.uploadFile || []).slice(0, this.uploadPreviewLimit);
    }

    get uploadOverflowCount(): number {
        return Math.max(0, (this.uploadFile || []).length - this.uploadPreviewLimit);
    }

    onFileSelect(event: any) {
        const files: FileList = event.target.files;
        if (!files || files.length === 0) return;

        const selected: File[] = Array.from(files);

        this.uploadError = '';

        this.uploadFile.push(...selected);
        this.service.render();
    }
    selectedIds: Set<string> = new Set();

    toggleItem(id: string | undefined) {
        if (!id) return;

        if (this.selectedIds.has(id)) {
            this.selectedIds.delete(id);
        } else {
            this.selectedIds.add(id);
        }

        this.service.render();
    }


    get selectedItems(): any[] {
        if (!this.items || !this.selectedIds) return [];
        return this.items.filter(
            it => it?.id && this.selectedIds.has(it.id)
        );
    }

    get selectedFiles(): any[] {
        return this.selectedItems.filter(
            it => it.type === 'file' && this.isProcessableFile(it)
        );
    }

    get selectedFolders(): any[] {
        return this.selectedItems.filter(
            it => it.type === 'dir'
        );
    }

    get isAllSelected(): boolean {
        if (!this.items || this.items.length === 0) return false;

        return this.items.every(it =>
            it?.name && this.selectedIds.has(it.name)
        );
    }

    toggleSelectAll() {
        if (this.isAllSelected) {
            // 현재 페이지의 항목들만 해제
            this.items.forEach(it => {
                if (it?.name) {
                    this.selectedIds.delete(it.name);
                }
            });
        } else {
            // 현재 페이지의 항목들만 선택
            this.items.forEach(it => {
                if (it?.name) {
                    this.selectedIds.add(it.name);
                }
            });
        }

        this.service.render();
    }



    private async uploadFilesToCurrentPath(pairs: { file: File; path: string }[]) {
        if (!pairs || pairs.length === 0) return;

        if (this.isUploading) {
            alert('이미 업로드가 진행 중입니다.');
            return;
        }

        this.isUploading = true;
        this.uploadCancelRequested = false;
        this.uploadTotalCount = pairs.length;
        this.uploadCompletedCount = 0;
        this.uploadProgress = 0;
        this.uploadCurrentName = '';
        this.showUploadProgressModal = true;
        this.service.render();

        const url = wiz.url('upload_formdata_file') + `?cwd=${encodeURIComponent(this.currentPath)}`;

        for (let i = 0; i < pairs.length; i++) {
            if (this.uploadCancelRequested) {
                break;
            }

            const p = pairs[i];
            this.uploadCurrentName = p.path;
            this.service.render();

            const formData = new FormData();
            formData.append('files[]', p.file, p.path);

            this.currentUploadAbort = new AbortController();
            let response: Response | null = null;
            let json: any = null;

            try {
                response = await fetch(url, {
                    method: 'POST',
                    body: formData,
                    signal: this.currentUploadAbort.signal
                });

                try {
                    json = await response.json();
                } catch (e) {
                    console.error('[UPLOAD] JSON parse error', e);
                }
            } catch (error: any) {
                if (error && error.name === 'AbortError') {
                    console.warn('[UPLOAD] 업로드가 취소되었습니다.');
                    break;
                }
                console.error('[UPLOAD ERROR]', error);
                alert('업로드 중 오류가 발생했습니다.');
                break;
            } finally {
                this.currentUploadAbort = null;
            }

            if (!response) break;

            if (!(response.ok && json && json.code === 200)) {
                const msg = json?.error || json?.data?.error || '업로드 실패';
                alert(msg);
                break;
            }

            this.uploadCompletedCount = i + 1;
            this.uploadProgress = Math.floor((this.uploadCompletedCount / this.uploadTotalCount) * 100);
            this.service.render();
        }

        // 업로드된 내용 반영
        try {
            await this.open(this.currentPath);
            this.selectedIds.clear();
        } catch (e) {
            console.error('[UPLOAD] open currentPath error after upload', e);
        }

        // 상태 초기화
        this.isUploading = false;
        this.showUploadProgressModal = false;
        this.uploadCurrentName = '';
        this.uploadProgress = 0;
        this.uploadTotalCount = 0;
        this.uploadCompletedCount = 0;
        this.uploadCancelRequested = false;
        this.currentUploadAbort = null;
        this.service.render();
    }

    async confirmUpload() {
        if (!this.uploadFile || this.uploadFile.length === 0) return;

        // 현재 폴더에 존재하는 파일 이름들
        const existingFiles = this.allItems
            .filter(it => it.type === "file")
            .map(it => it.name);

        const pairs: { file: File; path: string }[] = [];

        for (const file of this.uploadFile) {
            const fileName = file.name;

            if (existingFiles.includes(fileName)) {
                const replace = confirm(
                    `⚠ 이미 같은 이름의 파일이 존재합니다.\n\n` +
                    `파일명: ${fileName}\n\n` +
                    `기존 파일을 대체하시겠습니까?\n\n` +
                    `확인 = 대치\n취소 = 업로드 중단`
                );

                if (!replace) {
                    console.log("중복 파일 업로드 취소:", fileName);
                    continue;
                }

                // 기존 파일 삭제
                await wiz.call("delete_files", {
                    cwd: this.currentPath,
                    files: JSON.stringify([fileName])
                });

                console.log("기존 파일 삭제 후 대체됨:", fileName);
            }

            pairs.push({
                file,
                path: fileName
            });
        }

        if (pairs.length === 0) {
            alert("업로드할 파일이 없습니다.");
            return;
        }

        this.closeUpload();
        await this.uploadFilesToCurrentPath(pairs);
    }


    // 업로드 진행 중 취소
    cancelUploadInProgress() {
        if (!this.isUploading) return;
        if (!confirm('현재 진행 중인 업로드를 취소하시겠습니까?')) return;

        this.uploadCancelRequested = true;
        if (this.currentUploadAbort) {
            try {
                this.currentUploadAbort.abort();
            } catch (e) {
                console.error('[UPLOAD] abort error', e);
            }
        }
    }

    // ===== 드래그 앤 드롭 업로드 =====
    public onDropZoneDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    public onDropZoneDragEnter(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.dragCounter += 1;
        this.isDragOver = true;
        this.service.render();
    }

    public onDropZoneDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.dragCounter -= 1;
        if (this.dragCounter <= 0) {
            this.dragCounter = 0;
            this.isDragOver = false;
            this.service.render();
        }
    }

    public async onDropZoneDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        this.dragCounter = 0;
        this.isDragOver = false;
        await this.service.render();

        if (this.isUploading) {
            alert('이미 업로드가 진행 중입니다.');
            return;
        }

        const dt = event.dataTransfer;
        if (!dt) return;

        const pairs: { file: File; path: string }[] = [];

        const items = dt.items;
        if (items && items.length > 0) {
            const traverseEntry = (entry: any, parentPath: string): Promise<void> => {
                return new Promise((resolve) => {
                    if (!entry) {
                        resolve();
                        return;
                    }

                    if (entry.isFile) {
                        entry.file((file: File) => {
                            if (file) {
                                const relPath = parentPath
                                    ? `${parentPath}/${file.name}`
                                    : file.name;
                                pairs.push({ file, path: relPath });
                            }
                            resolve();
                        });
                    } else if (entry.isDirectory) {
                        const dirPath = parentPath
                            ? `${parentPath}/${entry.name}`
                            : entry.name;

                        const reader = entry.createReader();

                        const readAll = () => {
                            reader.readEntries((entries: any[]) => {
                                if (!entries || entries.length === 0) {
                                    resolve();
                                    return;
                                }
                                Promise.all(entries.map((e: any) => traverseEntry(e, dirPath)))
                                    .then(() => readAll());
                            });
                        };

                        readAll();
                    } else {
                        resolve();
                    }
                });
            };

            const tasks: Promise<void>[] = [];

            for (let i = 0; i < items.length; i++) {
                const item: any = items[i];
                const entry =
                    item.getAsEntry
                        ? item.getAsEntry()
                        : (item.webkitGetAsEntry ? item.webkitGetAsEntry() : null);

                if (entry) {
                    tasks.push(traverseEntry(entry, ''));
                } else if (item.kind === 'file') {
                    const file = item.getAsFile && item.getAsFile();
                    if (file) {
                        pairs.push({ file, path: file.name });
                    }
                }
            }

            await Promise.all(tasks);
        } else if (dt.files && dt.files.length > 0) {
            for (const file of Array.from(dt.files)) {
                pairs.push({ file, path: file.name });
            }
        }

        if (pairs.length === 0) return;

        await this.uploadFilesToCurrentPath(pairs);
    }

    //폴링 
    startOcrPolling() {
        console.log('[OCR] startOcrPolling ENTER');

        if (this.ocrPollingTimer) return;

        this.ocrPollingTimer = setInterval(() => {
            console.log('[OCR] polling tick (raw)');

            this.open(this.currentPath).then(() => {
                console.log('[OCR] open finished');
                this.service.render(); // 🔥 강제 렌더
            });

        }, 2000);
    }

    stopOcrPolling() {
        if (this.ocrPollingTimer) {
            clearInterval(this.ocrPollingTimer);
            this.ocrPollingTimer = null;
            console.log('[OCR] polling stopped');
        }
    }

    ocrModel: string = 'gemini-2.5-flash';

    private async collectEmbeddableRelPathsFromFolder(folderName: string): Promise<string[]> {
        const results: string[] = [];

        const startAbs = this.join(this.currentPath, folderName);
        const stack: Array<{ abs: string; rel: string }> = [{ abs: startAbs, rel: folderName }];

        const allowed = ['pdf', 'hwp', 'hwpx', 'txt'];

        while (stack.length > 0) {
            const cur = stack.pop();
            if (!cur) break;

            let res: any = null;
            try {
                res = await wiz.call('browse', { cwd: cur.abs });
            } catch (e) {
                console.error('[EMB] browse fail:', cur.abs, e);
                continue;
            }

            const items = res?.data?.items || [];
            const names = items.map((x: any) => x?.name).filter(Boolean);

            for (const it of items) {
                if (!it || !it.name) continue;

                if (it.type === 'dir') {
                    const nextAbs = this.join(cur.abs, it.name);
                    const nextRel = `${cur.rel}/${it.name}`;
                    stack.push({ abs: nextAbs, rel: nextRel });
                    continue;
                }

                if (it.type === 'file') {
                    const ext = this.getFileExt(it.name);
                    if (!allowed.includes(ext)) continue;

                    // 같은 폴더 내에 base_ocr.json이 있어야 임베딩 가능
                    const base = it.name.replace(/\.[^.]+$/, '');
                    const ocrJson = `${base}_ocr.json`;

                    if (!names.includes(ocrJson)) continue;

                    results.push(`${cur.rel}/${it.name}`);
                }
            }
        }

        return results;
    }

    private async collectPdfRelPathsFromFolder(folderName: string): Promise<string[]> {
        const results: string[] = [];

        // 시작점: 현재 경로 + 선택된 폴더
        const startAbs = this.join(this.currentPath, folderName);

        // stack: { abs: 실제 browse할 절대 cwd, rel: currentPath 기준 상대경로 prefix }
        const stack: Array<{ abs: string; rel: string }> = [{ abs: startAbs, rel: folderName }];

        while (stack.length > 0) {
            const cur = stack.pop();
            if (!cur) break;

            let res: any = null;
            try {
                res = await wiz.call('browse', { cwd: cur.abs });
            } catch (e) {
                console.error('[OCR] browse fail:', cur.abs, e);
                continue;
            }

            const items = res?.data?.items || [];

            for (const it of items) {
                if (!it || !it.name) continue;

                if (it.type === 'dir') {
                    const nextAbs = this.join(cur.abs, it.name);
                    const nextRel = `${cur.rel}/${it.name}`;
                    stack.push({ abs: nextAbs, rel: nextRel });
                    continue;
                }

                if (it.type === 'file') {
                    const lower = String(it.name).toLowerCase();
                    if (lower.endsWith('.pdf')) {
                        // currentPath 기준 상대경로
                        results.push(`${cur.rel}/${it.name}`);
                    }
                }
            }
        }

        return results;
    }

    async activeOCR() {
        console.log('[OCR] activeOCR called');

        const files = this.getCheckedFiles();
        const folders = this.getCheckedFolders();

        if (files.length === 0 && folders.length === 0) {
            alert('텍스트 추출할 파일 또는 폴더를 선택해 주세요.');
            return;
        }

        if (files.length > 0 && folders.length > 0) {
            alert('폴더와 파일을 동시에 선택할 수 없습니다.\n파일만 또는 폴더만 선택해 주세요.');
            return;
        }

        // ✅ OCR 시작 확인 추가
        const fileCount = files.length > 0 ? files.length : folders.length;
        const targetType = files.length > 0 ? '파일' : '폴더';

        if (!confirm(`선택한 ${fileCount}개의 ${targetType}에 대해 OCR 텍스트 추출을 시작하시겠습니까?`)) {
            return;
        }

        let relPaths: string[] = [];

        if (files.length > 0) {
            // 현재 폴더의 파일들(기존 동작)
            relPaths = files
                .map(f => this.getOcrTargetName(f))
                .filter((n: any) => !!n)
                .map((n: any) => String(n));
        } else {
            // 선택한 폴더들의 하위 PDF 전부 수집 (폴더 여러 개면 병렬 수집)
            const folderNames = folders
                .map(f => String(f?.name || '').trim())
                .filter(n => !!n);

            const pdfLists = await Promise.all(
                folderNames.map(name => this.collectPdfRelPathsFromFolder(name))
            );

            relPaths = pdfLists.flat();
        }

        // 중복 제거
        relPaths = Array.from(new Set(relPaths));

        if (relPaths.length === 0) {
            alert('선택한 범위에서 PDF 파일을 찾지 못했습니다.');
            return;
        }

        // 폴링(원하시면 유지) - 상태 갱신용
        // this.startOcrPolling();

        // ✅ 여기서부터 "동시에 병렬 실행"
        const llm = this.ocrModel;
        const limit = pLimit(10); // 동시 3개

        const promises = relPaths.map((rel) =>
            limit(() => {
                const params = new URLSearchParams({
                    cwd: this.currentPath,
                    files: JSON.stringify([rel]),
                    llm
                }).toString();

                return wiz.call('start_ocr_storage?' + params);
            })
        );

        const results = await Promise.allSettled(promises);

        const successCount = results.filter(r => r.status === 'fulfilled' && (r as any).value?.code === 200).length;
        const failCount = results.length - successCount;

        if (failCount > 0) {
            console.warn('[OCR] some failed:', results);
        }

        await this.open(this.currentPath);
        await this.service.render();

        alert(`OCR 실행 요청 완료\n성공: ${successCount}건\n실패: ${failCount}건`);
    }

    async loadPDF(filename: string) {
        const pdfUrl = wiz.url('get_pdf_file')
            + `?cwd=${encodeURIComponent(this.currentPath)}`
            + `&filename=${encodeURIComponent(filename)}`;

        console.log('[PDF] URL:', pdfUrl);

        try {
            this.pdfLoadingProgress = '문서 로딩 중...';
            this.cdr.detectChanges();

            const response = await fetch(pdfUrl);
            console.log('[PDF] Response status:', response.status);
            console.log('[PDF] Content-Type:', response.headers.get('content-type'));

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            console.log('[PDF] Blob size:', blob.size, 'Type:', blob.type);

            this.pdfLoadingProgress = 'PDF 파싱 중...';
            this.cdr.detectChanges();

            const blobUrl = URL.createObjectURL(blob);

            const loadingTask = pdfjsLib.getDocument({
                url: blobUrl,
                isEvalSupported: false,
                useSystemFonts: true
            });

            this.pdfDoc = await loadingTask.promise;

            console.log(`[PDF] 로드 완료: ${this.pdfDoc.numPages} 페이지`);

            this.pdfLoadingProgress = '첫 페이지 렌더링 중...';
            this.cdr.detectChanges();

            await this.renderPDFPage(1);

            URL.revokeObjectURL(blobUrl);

            await this.service.render();

        } catch (error) {
            console.error('[PDF] 로드 실패:', error);
            this.pdfDoc = null;
            this.pdfPageCanvas = '';
            this.pdfLoading = false;
            alert('PDF 로드에 실패했습니다.');
            this.cdr.detectChanges();
        }
    }

    async renderPDFPage(pageNum: number) {
        if (!this.pdfDoc) {
            console.warn('[PDF] pdfDoc이 null입니다.');
            return;
        }

        try {
            console.log(`[PDF] ========== 페이지 ${pageNum} 렌더링 시작 ==========`);
            console.log(`[PDF] 현재 pdfZoomLevel:`, this.pdfZoomLevel);

            const page = await this.pdfDoc.getPage(pageNum);

            const scale = this.pdfZoomLevel;
            console.log(`[PDF] 사용할 scale 값:`, scale);

            const viewport = page.getViewport({ scale });
            console.log(`[PDF] Viewport 크기: ${viewport.width}x${viewport.height}`);

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            if (!context) {
                console.error('[PDF] Canvas context를 가져올 수 없습니다.');
                return;
            }

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // 실제 크기 저장
            this.pdfCanvasWidth = canvas.width;
            this.pdfCanvasHeight = canvas.height;

            console.log(`[PDF] Canvas 크기 설정: ${canvas.width}x${canvas.height}`);

            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };

            await page.render(renderContext).promise;

            this.pdfPageCanvas = canvas.toDataURL('image/png');

            console.log(`[PDF] 페이지 ${pageNum} 렌더링 완료`);
            console.log(`[PDF] Canvas 크기: ${this.pdfCanvasWidth}x${this.pdfCanvasHeight}`);
            console.log(`[PDF] ========== 렌더링 완료 ==========`);

            this.cdr.detectChanges();
            await this.service.render();

        } catch (error) {
            console.error(`[PDF] 페이지 ${pageNum} 렌더링 실패:`, error);
        }
    }
    async goToPageInput() {
        const pageNum = this.pdfPageInput;

        if (!pageNum || pageNum < 1 || pageNum > this.ocrResults.length) {
            alert(`1부터 ${this.ocrResults.length} 사이의 페이지를 입력하세요.`);
            this.pdfPageInput = this.currentOCRIndex + 1;
            return;
        }

        await this.changePage(pageNum - 1);
    }

    async onPageInputKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            await this.goToPageInput();
        }
    }

    async zoomIn() {
        console.log('[ZOOM] ========== zoomIn 시작 ==========');
        console.log('[ZOOM] 현재 pdfZoomLevel:', this.pdfZoomLevel);
        console.log('[ZOOM] maxZoom:', this.maxZoom);

        if (this.pdfZoomLevel >= this.maxZoom) {
            console.log('[ZOOM] 최대 줌 레벨 도달, 리턴');
            return;
        }

        const oldZoom = this.pdfZoomLevel;
        this.pdfZoomLevel = Math.min(this.pdfZoomLevel + 0.25, this.maxZoom);
        console.log('[ZOOM] 줌 변경:', oldZoom, '->', this.pdfZoomLevel);

        if (!this.pdfDoc) {
            console.log('[ZOOM] pdfDoc이 null, 리턴');
            return;
        }

        if (!this.ocrResults || this.ocrResults.length === 0) {
            console.log('[ZOOM] ocrResults 없음, 리턴');
            return;
        }

        const pageNum = this.ocrResults[this.currentOCRIndex].page;
        console.log('[ZOOM] 페이지 재렌더링 시작:', pageNum);

        await this.renderPDFPage(pageNum);
        console.log('[ZOOM] ========== zoomIn 완료 ==========');
    }

    async zoomOut() {
        console.log('[ZOOM] ========== zoomOut 시작 ==========');
        console.log('[ZOOM] 현재 pdfZoomLevel:', this.pdfZoomLevel);
        console.log('[ZOOM] minZoom:', this.minZoom);

        if (this.pdfZoomLevel <= this.minZoom) {
            console.log('[ZOOM] 최소 줌 레벨 도달, 리턴');
            return;
        }

        const oldZoom = this.pdfZoomLevel;
        this.pdfZoomLevel = Math.max(this.pdfZoomLevel - 0.25, this.minZoom);
        console.log('[ZOOM] 줌 변경:', oldZoom, '->', this.pdfZoomLevel);

        if (!this.pdfDoc) {
            console.log('[ZOOM] pdfDoc이 null, 리턴');
            return;
        }

        if (!this.ocrResults || this.ocrResults.length === 0) {
            console.log('[ZOOM] ocrResults 없음, 리턴');
            return;
        }

        const pageNum = this.ocrResults[this.currentOCRIndex].page;
        console.log('[ZOOM] 페이지 재렌더링 시작:', pageNum);

        await this.renderPDFPage(pageNum);
        console.log('[ZOOM] ========== zoomOut 완료 ==========');
    }
    async zoomReset() {
        console.log('[ZOOM] zoomReset 호출, 현재:', this.pdfZoomLevel);

        this.pdfZoomLevel = 1.5;
        console.log('[ZOOM] 줌 레벨 1.5로 리셋');

        if (this.pdfDoc) {
            const pageNum = this.ocrResults[this.currentOCRIndex].page;
            console.log('[ZOOM] 페이지 재렌더링:', pageNum);
            await this.renderPDFPage(pageNum);
        } else {
            console.log('[ZOOM] pdfDoc이 null입니다');
        }
    }
    get zoomPercent(): number {
        return Math.round((this.pdfZoomLevel / 1.5) * 100);
    }
    async openOCRResult(it: any) {
        this.selectedOCRGroup = it;

        // 🔥 로딩 시작
        this.pdfLoading = true;
        this.pdfLoadingProgress = 'OCR 결과 로딩 중...';
        this.showOCRModal = true;

        // 🔥 초기화
        this.pdfZoomLevel = 1.5;
        this.pdfPageInput = 1;

        this.cdr.detectChanges();
        await this.service.render();

        const targetName = this.getOcrTargetName(it);
        const res = await wiz.call('get_ocr_result_file', {
            cwd: this.currentPath,
            filename: targetName
        });

        if (!res || res.code !== 200) {
            this.pdfLoading = false;
            alert('OCR 결과가 없습니다.');
            this.showOCRModal = false;
            return;
        }

        const parsed = res.data?.data;

        if (!parsed || !Array.isArray(parsed.pages)) {
            this.pdfLoading = false;
            alert('OCR 데이터가 올바르지 않습니다.');
            this.showOCRModal = false;
            return;
        }

        if (parsed.pages.length === 0) {
            this.ocrResults = [];
            this.ocrText = '';
            this.currentOCRIndex = 0;
        } else {
            this.ocrResults = parsed.pages.map((p: any) => ({
                page: p.page,
                text: p.text || ''
            }));

            this.currentOCRIndex = 0;
            this.ocrText = this.ocrResults[0].text || '';
            this.pdfPageInput = 1;  // 🔥 입력 필드 초기화
        }

        // 🔥 PDF 초기화
        this.pdfDoc = null;
        this.pdfPageCanvas = '';
        this.cdr.detectChanges();

        // 🔥 PDF 파일인 경우 로드
        const ext = this.getFileExt(targetName);
        if (ext === 'pdf') {
            this.pdfLoadingProgress = 'PDF 로딩 중...';
            this.cdr.detectChanges();
            await this.service.render();

            await this.loadPDF(targetName);
        }

        // 🔥 로딩 완료
        this.pdfLoading = false;
        this.cdr.detectChanges();
        await this.service.render();
    }
    
    closeOCRModal() {
        this.showOCRModal = false;
        this.selectedOCRGroup = null;
        this.ocrResults = [];
        this.currentOCRIndex = 0;

        // 🔥 PDF 관련 정리
        this.pdfDoc = null;
        this.pdfPageCanvas = '';
        this.ocrText = '';
        this.pdfLoading = false;
        this.pdfLoadingProgress = '';

        // 🔥 줌 및 페이지 입력 초기화
        this.pdfZoomLevel = 1.5;
        this.pdfPageInput = 1;
        this.pdfCanvasWidth = 0;
        this.pdfCanvasHeight = 0;

        this.cdr.detectChanges();
        this.service.render();
    }

    async changePage(index: number) {
        if (index < 0 || index >= this.ocrResults.length) return;

        this.currentOCRIndex = index;
        this.ocrText = this.ocrResults[index].text || '';

        // 🔥 페이지 입력 필드 업데이트
        this.pdfPageInput = index + 1;

        // 🔥 PDF 페이지도 동기화
        if (this.pdfDoc) {
            const pageNum = this.ocrResults[index].page;
            await this.renderPDFPage(pageNum);
        }

        this.cdr.detectChanges();
        await this.service.render();
    }

    async nextPage() {
        if (this.currentOCRIndex < this.ocrResults.length - 1) {
            await this.changePage(this.currentOCRIndex + 1);
        }
    }

    async prevPage() {
        if (this.currentOCRIndex > 0) {
            await this.changePage(this.currentOCRIndex - 1);
        }
    }

    // ===== 임베딩 =====
    async activeEmbedding() {
        console.log('[EMBEDDING] activeEmbedding called');

        const files = this.getCheckedFiles();
        const folders = this.getCheckedFolders();

        if (files.length === 0 && folders.length === 0) {
            alert('임베딩할 파일 또는 폴더를 선택해 주세요.');
            return;
        }

        if (files.length > 0 && folders.length > 0) {
            alert('폴더와 파일을 동시에 선택할 수 없습니다.\n파일만 또는 폴더만 선택해 주세요.');
            return;
        }

        // ✅ 임베딩 시작 확인 추가
        const fileCount = files.length > 0 ? files.length : folders.length;
        const targetType = files.length > 0 ? '파일' : '폴더';

        if (!confirm(`선택한 ${fileCount}개의 ${targetType}에 대해 임베딩 작업을 시작하시겠습니까?\n\n※ OCR이 완료된 파일만 처리됩니다.`)) {
            return;
        }

        let relPaths: string[] = [];

        if (files.length > 0) {
            // 파일은 현재 폴더 기준 파일명만
            // (하위 경로를 지원하려면 여기서도 상대경로 형태로 넘겨야 합니다)
            relPaths = files
                .map(f => String(this.getOcrTargetName(f) || '').trim())
                .filter(n => !!n);
        } else {
            // 폴더 하위 전체 수집
            const folderNames = folders
                .map(f => String(f?.name || '').trim())
                .filter(n => !!n);

            const lists = await Promise.all(
                folderNames.map(name => this.collectEmbeddableRelPathsFromFolder(name))
            );
            relPaths = lists.flat();
        }

        relPaths = Array.from(new Set(relPaths));

        if (relPaths.length === 0) {
            alert('선택한 범위에서 임베딩 가능한 파일(OCR 완료)을 찾지 못했습니다.');
            return;
        }

        // UI 표시용: 현재 화면에 보이는 파일들은 processing으로 표시(폴더 하위는 화면에 없을 수도 있음)
        this.allItems.forEach(it => {
            if (it?.type === 'file' && relPaths.includes(it.name)) {
                it.embedding = 'processing';
            }
        });
        await this.service.render();

        const limit = pLimit(5);

        const promises = relPaths.map((rel) =>
            limit(async () => {
                const params = new URLSearchParams({
                    cwd: this.currentPath,
                    files: JSON.stringify([rel])
                }).toString();

                try {
                    const res = await wiz.call('start_embedding?' + params);
                    if (res?.code !== 200) {
                        console.error('[EMBEDDING] fail:', rel, res?.error);
                        return { ok: false, rel };
                    }
                    return { ok: true, rel };
                } catch (e) {
                    console.error('[EMBEDDING] exception:', rel, e);
                    return { ok: false, rel };
                }
            })
        );

        const results = await Promise.all(promises);
        const ok = results.filter((r: any) => r.ok).length;
        const fail = results.length - ok;

        await this.open(this.currentPath); // 상태 갱신
        await this.service.render();

        alert(`임베딩 실행 요청 완료\n성공: ${ok}건\n실패: ${fail}건`);
        this.selectedIds.clear();
    }



    // ===== 메뉴 / 다운로드 =====
    toggleDrop(it: any, event: MouseEvent) {
        event.stopPropagation();

        this.items.forEach((x: any) => {
            if (x !== it) x._menuOpen = false;
        });

        it._menuOpen = !it._menuOpen;
        this.service.render();
    }

    getOriginalLabel(ext: string): string {
        if (!ext) return '파일';
        if (ext === 'pdf') return 'PDF';
        if (ext === 'hwp') return 'HWP';
        if (ext === 'hwpx') return 'HWPX';
        if (ext === 'txt') return 'TXT';
        return ext.toUpperCase();
    }

    downloadOriginalFile(it: any, ext?: string) {
        const filename = ext && it?.fileVariants?.[ext]
            ? it.fileVariants[ext]
            : it.name;

        if (!filename) return;

        const url =
            wiz.url('download_pdf_file')
            + `?cwd=${encodeURIComponent(this.currentPath)}`
            + `&filename=${encodeURIComponent(filename)}`;

        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
    }

    downloadOcrJson(it: any) {
        const targetName = this.getOcrTargetName(it);
        const base = it?.baseName || this.getBaseName(targetName);
        const jsonFile = `${base}_ocr.json`;

        const url =
            wiz.url('get_ocr_result_file')
            + `?cwd=${encodeURIComponent(this.currentPath)}`
            + `&filename=${encodeURIComponent(targetName)}`;

        const link = document.createElement('a');
        link.href = url;
        link.download = jsonFile;
        link.click();
    }

    downloadEmbeddingJson(it: any) {
        const targetName = this.getOcrTargetName(it);
        const base = it?.baseName || this.getBaseName(targetName);
        const jsonFile = `${base}_embedding.json`;

        const url =
            wiz.url('get_embedding_file')
            + `?cwd=${encodeURIComponent(this.currentPath)}`
            + `&filename=${encodeURIComponent(targetName)}`;

        const link = document.createElement('a');
        link.href = url;
        link.download = jsonFile;
        link.click();
    }

    // ===== 벡터DB 삽입 =====
    async activeVectorDBInsert() {
        const targets = this.getCheckedFiles();

        if (targets.length === 0) {
            alert('벡터DB에 삽입할 파일을 선택해 주세요.');
            return;
        }

        const files = targets.map(t => t.name);

        const params = new URLSearchParams({
            cwd: this.currentPath,
            files: JSON.stringify(files)
        }).toString();

        if (!confirm(
            '선택한 파일의 임베딩 벡터가 기존 벡터 컬렉션에 추가됩니다.\n\n계속 진행하시겠습니까?'
        )) return;

        try {
            // ✅ 로딩 UI만 표시
            this.showUploadProgressModal = true;
            this.uploadCurrentName = '벡터 DB 삽입 중...';
            await this.service.render();

            const res = await wiz.call('insert_to_milvus?' + params);
            console.log('[insert_to_milvus]', res);

            if (res?.code !== 200) {
                throw new Error(res?.error || 'Vector DB Insert 실패');
            }

            const info = res?.data?.data || {};
            alert(
                `벡터 DB 삽입 완료\n` +
                `컬렉션명: ${info.collection}\n` +
                `삽입 건수: ${info.inserted}`
            );

            this.selectedIds.clear();
            await this.open(this.currentPath);

        } catch (e) {
            console.error(e);
            alert('벡터DB 삽입 중 오류가 발생했습니다.');
        } finally {
            this.showUploadProgressModal = false;
            await this.service.render();
        }
    }




    // ===== 정렬 + 페이지네이션 =====
    private sortItems(items: any[]): any[] {
        const dirs = items.filter((it: any) => it.type === 'dir');
        const files = items.filter((it: any) => it.type !== 'dir');

        const byMtimeDesc = (a: any, b: any) => {
            const ma = a.mtime || 0;
            const mb = b.mtime || 0;
            return mb - ma;
        };

        dirs.sort(byMtimeDesc);
        files.sort(byMtimeDesc);

        return [...dirs, ...files];
    }
    // ==== 정렬 =====
    private applySortAndPagination() {
        const sorted = this.sortByOption(this.allItems || []);

        this.totalPages = Math.max(1, Math.ceil(sorted.length / this.pageSize));

        if (this.currentPage < 1) this.currentPage = 1;
        if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;

        this.items = sorted.slice(start, end);
    }

    private sortByOption(items: any[]): any[] {
        const sorted = [...items];

        sorted.sort((a, b) => {
            const aIsDir = a.type === 'dir';
            const bIsDir = b.type === 'dir';

            if (aIsDir && !bIsDir) return -1;
            if (!aIsDir && bIsDir) return 1;
            switch (this.sortOption) {
                case "name_asc":
                    return (a.displayName || a.name || '').localeCompare(b.displayName || b.name || '');

                case "name_desc":
                    return (b.displayName || b.name || '').localeCompare(a.displayName || a.name || '');

                case "date_new":
                    return (b.mtime ?? 0) - (a.mtime ?? 0);

                case "date_old":
                    return (a.mtime ?? 0) - (b.mtime ?? 0);

                case "size_big":
                    return (b.size ?? 0) - (a.size ?? 0);

                case "size_small":
                    return (a.size ?? 0) - (b.size ?? 0);

                default:
                    // 기본: 최신순
                    return (b.mtime ?? 0) - (a.mtime ?? 0);
            }
        });

        return sorted;
    }



    public get pagesArray(): number[] {
        const maxButtons = 10;

        if (this.totalPages <= maxButtons) {
            return Array.from({ length: this.totalPages }, (_, i) => i + 1);
        }

        const groupIndex = Math.floor((this.currentPage - 1) / maxButtons);
        const start = groupIndex * maxButtons + 1;
        const end = Math.min(start + maxButtons - 1, this.totalPages);

        const length = end - start + 1;
        return Array.from({ length }, (_, i) => start + i);
    }

    public goToPage(page: number) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
        // 페이지 이동 시 현재 페이지의 체크 상태 초기화
        this.clearCurrentPageSelection();
        this.applySortAndPagination();
        this.service.render();
    }

    public goPrevPage() {
        if (this.currentPage <= 1) return;
        this.currentPage -= 1;
        // 페이지 이동 시 현재 페이지의 체크 상태 초기화
        this.clearCurrentPageSelection();
        this.applySortAndPagination();
        this.service.render();
    }

    public goNextPage() {
        if (this.currentPage >= this.totalPages) return;
        this.currentPage += 1;
        // 페이지 이동 시 현재 페이지의 체크 상태 초기화
        this.clearCurrentPageSelection();
        this.applySortAndPagination();
        this.service.render();
    }

    // 현재 페이지의 선택 항목 초기화
    private clearCurrentPageSelection() {
        this.items.forEach(it => {
            if (it?.name) {
                this.selectedIds.delete(it.name);
            }
        });
    }
}

export default PortalRawdataDetailComponent;